import { RuleCategorizationType } from './RuleCategorizationType';

export const RuleCategorizationTypeOptions = [
    {
        id: RuleCategorizationType.Residential,
        name: 'Residential',
    },
    {
        id: RuleCategorizationType.Commercial,
        name: 'Commercial',
    },
];
